/*
 * Project: LegalPlace assistant
 * File: src\components\misc\checkbox.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { generateId1 } from '../utils/misc';
// the communication to low level
import {
  initOutputOption, initOutputVariable, editOption, editVariable,
} from '../../redux/actions/output';
// some componentns
import LpHelper from './helper';

import { raiseOption } from '../../logic/action_counter';
import { rsRegisterAction } from '../utils/radio_show';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import lpApp from '../../app/lp_app';


// inputs are id, label, ischecked(after)
// FIXME: when we check and get back to it, we lose the value
class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.updateCheckbox = this.updateCheckbox.bind(this);
  }

  componentWillMount() {
    // console.log(this.props.exists);
    const id = this.props.copy === -2 ? this.props.id : `${this.props.id}_${this.props.copy}`;
    const { value } = lpApp.indexes.options.getOption(id);
    if (!this.props.exists) {
      this.props.initializeOutput(this.props.id,
        this.props.lpKey,
        this.props.ovc,
        value,
        this.props.isDuplicate,
        this.props.copy);
    }
    // this.forceUpdate();
  }

  updateCheckbox() {
    if (this.props.checked) this.props.editOutput(false);
    else this.props.editOutput(true);
    let cId = this.props.id;
    if (this.props.isDuplicate) {
      cId = `${cId}_${this.props.copy}`;
    }
    raiseOption(cId);
    rsRegisterAction(this.props.id, this.props.parent, this.props.isDuplicate, this.props.copy);
    // this.forceUpdate();
  }

  render() {
    return (
      <div
        data-type="checkbox"
        data-id={this.props.id}
        data-is-duplicate={this.props.isDuplicate}
        data-copy={this.props.copy}
        className="form-group wzog-option"
        key={generateId1(4)}
      >

        <input
          type="checkbox"
          id={this.props.lpKey}
          onClick={() => this.updateCheckbox()}
          checked={this.props.checked}
          className=""
          onChange={() => {}}
        />
        <label htmlFor={this.props.lpKey}>
          {this.props.label}
          {'helper' in lpApp.references.getOption(this.props.id).meta && lpApp.references.getOption(this.props.id).meta.helper.length > 0 && <LpHelper text={lpApp.references.getOption(this.props.id).meta.helper} />}
        </label>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  let checked = false;
  let exists = false;
  let uiid = '';
  // preparing the ids
  const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;

  if (ownProps.ovc === 'o') {
    const opt = lpGetOptionById(cId);

    if (typeof opt !== 'undefined') {
      checked = opt.value;
      exists = true;
      uiid = opt.key;
    }
  } else {
    const opt = lpGetVariableById(cId);
    if (typeof opt !== 'undefined') {
      checked = opt.value;
      exists = true;
      uiid = opt.key;
    }
  }
  return {
    // TODO: optimize the call of checkUIExists
    exists,
    checked, // exists ? checked : default_continue_value,
    uiid,
    sectionId: state.contract.currentSection,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // this case, parent = key
  initializeOutput: (id, parent, genre, value, isDuplicate, copy) => {
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    // let c_pid = !isDuplicate ? parent : parent + '_' + copy;
    // console.log(genre)
    if (genre === 'o') dispatch(initOutputOption(cId, parent, value));
    else dispatch(initOutputVariable(cId, parent, value));
  },
  editOutput: (val) => {
    const cId = !ownProps.isDuplicate ? ownProps.id : `${ownProps.id}_${ownProps.copy}`;
    if (ownProps.ovc === 'o') {
      dispatch(editOption(cId, val));
    } else {
      dispatch(editVariable(cId, val));
    }
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
});

const LpCheckBox = connect(mapStateToProps, mapDispatchToProps)(CheckBox);

export default LpCheckBox;



// WEBPACK FOOTER //
// ./src/components/misc/checkbox.js